module.exports = __webpack_public_path__ + "img/3.6e9abdf0.png";